import { BaseProviderInstanceResourceModel } from './base-provider-instance-resource-model';
import { ChangeResultItem } from './change-result-item';

export class ChangeResult<A> {
  deleted: A[];
  changed: ChangeResultItem<A>[];
  inserted: A[];
  isEqual: boolean;
}
